import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducer.js";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  createStateSyncMiddleware,
  initStateWithPrevTab,
} from "redux-state-sync";
import { loadFilterState, saveFilterState, validateFilterState } from "./utils/statePersistence.js";

// Enhanced logger middleware with better state management
const loggerMiddleware = (storeAPI) => (next) => (action) => {
  console.log("dispatching", action);
  let result = next(action);
  console.log("next state", storeAPI.getState());
  
  // Only persist filter-related state, not the entire store
  const currentState = storeAPI.getState();
  const filterState = currentState.filter;
  
  // Use the utility function to save state
  saveFilterState(filterState);
  
  return result;
};

// Configuration for state sync - exclude filter actions to prevent conflicts
const config = {
  blacklist: [
    "filter/updateDateFilter",
    "filter/updateMarketplace", 
    "filter/updateInventoryMarketplace",
    "filter/updateQuickInvMarketplace",
    "filter/updatePoInvMarketplace",
    "filter/updateReviewFilter",
    "filter/updateSliderFilter"
  ]
};

const middlewares = [createStateSyncMiddleware(config)];

const middlewareEnhancer = composeWithDevTools(
  applyMiddleware(loggerMiddleware, ...middlewares)
);

// Load persisted state using utility function
const persistedState = loadFilterState();
let initialState = undefined;

if (persistedState && validateFilterState(persistedState)) {
  // Remove metadata fields before setting initial state
  const { lastUpdated, tabId, ...cleanState } = persistedState;
  initialState = { filter: cleanState };
}

// Create store with persisted state
const store = createStore(
  rootReducer, 
  initialState,
  middlewareEnhancer
);

// Initialize state sync
initStateWithPrevTab(store);

export default store;
